import { Injectable } from '@angular/core';
import { ProviderInvitation, ProviderInvitationInfo } from '@models';
import { HttpService } from '@services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProviderInvitationApiService extends HttpService<void> {
  protected override readonly collectionPath = '/admin/provider-invitations';

  inviteProvider(body: ProviderInvitation): Observable<void> {
    return this.http.post<void>(this.apiUrl, body);
  }

  getInfoByToken(
    token: string,
    email: string
  ): Observable<ProviderInvitationInfo> {
    return this.http.get<ProviderInvitationInfo>(
      `${this.apiRootUrl}/provider-invitations/${token}`,
      { params: this.getHttpParameters({ email }) }
    );
  }
}
